var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "countdownContainer" }, [
        _c("div", { staticClass: "counterContainer clearfix" }, [
          _c("div", { staticClass: "digitContainer" }, [
            _vm._v(_vm._s(_vm._f("firstDigit")(_vm.days)))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "digitContainer second" }, [
            _vm._v(_vm._s(_vm._f("secondDigit")(_vm.days)))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "digitContainer" }, [
            _vm._v(_vm._s(_vm._f("firstDigit")(_vm.hours)))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "digitContainer second" }, [
            _vm._v(_vm._s(_vm._f("secondDigit")(_vm.hours)))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "digitContainer" }, [
            _vm._v(_vm._s(_vm._f("firstDigit")(_vm.minutes)))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "digitContainer last" }, [
            _vm._v(_vm._s(_vm._f("secondDigit")(_vm.minutes)))
          ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "textContainer clearfix" }, [
      _c("div", { staticClass: "textContainerElement" }, [_vm._v("Tagen")]),
      _vm._v(" "),
      _c("div", { staticClass: "textContainerElement" }, [_vm._v("Stunden")]),
      _vm._v(" "),
      _c("div", { staticClass: "textContainerElement last" }, [
        _vm._v("Minuten")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e2ae88e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2ae88e8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Countdown.vue
// module id = 605
// module chunks = 2